import React from 'react';

import ChatIcon from '~/components/AiChat/SideBarDialog/icons/ChatIcon';
import { Text } from '~/components/core';
import Tooltip from '~/components/core/Atomic/Tooltip';
import { useTextOverflow } from '~/components/hooks/useTextOverflow';
import colors from '~/theme/tailwind/colors';

interface FullScreenChatHistoryItemProps {
  displayTitle: string;
  onClick?: () => void;
}

export const ListChatHistoryItem: React.FC<FullScreenChatHistoryItemProps> = ({ displayTitle, onClick }) => {
  const { textContainerRef, isOverflowing } = useTextOverflow(displayTitle);

  return (
    <div
      className="flex w-full cursor-pointer items-center gap-8 rounded-lg bg-white py-12 pl-8 hover:bg-white/50"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <ChatIcon size={16} iconColor={colors.blue[600]} className="min-w-16" />
      <Tooltip title={displayTitle} disableHoverListener={!isOverflowing}>
        <div ref={textContainerRef} className="min-w-0 overflow-hidden">
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} className="line-clamp-1">
            {displayTitle}
          </Text>
        </div>
      </Tooltip>
    </div>
  );
};
